// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"fed1c358","148":"a0176c82","346":"0482770e","388":"8dbb706e","578":"d7a76903","963":"2f78d94d"}[chunkId] + ".chunk.js";
};